import { clientPublic, clientPublicService } from 'helper/axios'
import { handleError } from 'helper/rest'
import { encodeId } from 'helper/sqids'
let resError = ''
export const getDataGroupORCategory = async ({ token, company_id, level, level_id }) => {
  try {
    return await clientPublic
      .get(
        `projectgroup?company_id=${company_id}?&level=${level}&level_id=${level_id}&limit=999`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const postDataGroupORCategory = async ({ params, token }) => {
  try {

    if(params.level === 1) { //Create project Group
      return await clientPublicService
        .post(`/core/management/project-group`, params, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response
        })
        .catch((error) => {
          const { response } = error
          if ([401, 403].includes(response.status)) {
            return handleError(response)
          }
          return response
        })
    } else if (params.level === 2) { //Create project Cate
      return await clientPublicService
        .post(`/core/management/project-category`, params, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response
        })
        .catch((error) => {
          const { response } = error
          if ([401, 403].includes(response.status)) {
            return handleError(response)
          }
          return response
        })
    }
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const putDataGroupORCategory = async ({ params, token }) => {
  try {
    if(params.level === 1) {
      return await clientPublicService
        .put(`/core/management/project-group/${encodeId(params.id)}`, params, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response
        })
        .catch((error) => {
          const { response } = error
          if ([401, 403].includes(response.status)) {
            return handleError(response)
          }
          return response
        })
    } else if (params.level === 2){
      return await clientPublicService
        .put(`/core/management/project-category/${encodeId(params.id)}`, params, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response
        })
        .catch((error) => {
          const { response } = error
          if ([401, 403].includes(response.status)) {
            return handleError(response)
          }
          return response
        })
    }
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const deleteDataGroupORCategory = async ({ params, token }) => {
  try {
    if(params.state === 'project_group') {
      return await clientPublicService
        .delete(`/core/management/project-group/${encodeId(params.id)}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response
        })
        .catch((error) => {
          const { response } = error
          if ([401, 403].includes(response.status)) {
            return handleError(response)
          }
          return response
        })
    } else if (params.state === 'project_cat') {
      return await clientPublicService
        .delete(`/core/management/project-category/${encodeId(params.id)}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response
        })
        .catch((error) => {
          const { response } = error
          if ([401, 403].includes(response.status)) {
            return handleError(response)
          }
          return response
        })
    }
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultCompany = async ({ token }) => {
  try {
    return await clientPublic
      .get(`company`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTree = async ({ token, language }) => {
  try {
    return await clientPublic
      .get(`projectgroup/tree?lang=${language}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// new api service-project
export const getDataGroupORCategoryV2 = async ({
  token,
  company_id,
  level,
  level_id,
}) => {
  try {
    let params = {}
    if (level === 1 && level_id === 0) {
      return await clientPublicService
      .get(`core/management/project-category/${encodeId(company_id)}`, {
        // params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
    } else if (level === 2 && level_id !== 0) {
      return await clientPublicService
      .get(`core/management/project-group/${encodeId(level_id)}/project-group`, {
        // params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
    } else if (level === 3 && level_id !== 0) {
      params = {
        project_category_id: level_id,
      }
    }

    // For level 3, use core service with POST endpoint
    if (level === 3 && level_id !== 0) {
      return await clientPublicService
        .post(`/core/management/project-imperative/list`, params, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response
        })
        .catch((error) => {
          const { response } = error
          if ([401, 403].includes(response.status)) {
            return handleError(response)
          }
          return response
        })
    }

    
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultCompanyV2 = async ({ token }) => {
  try {
    return await clientPublicService
      .get(`core/management/company`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeV3 = async ({ token }) => {
  try {
    return await clientPublicService
      .post(
        `/core/management/project-group/tree`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getImperativelist = async ({ token }) => {
  try {
    return await clientPublicService
      .post(
        `/core/management/project-imperative/list`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const saveStrategicImperative = async ({ token, params }) => {
  try {
    return await clientPublicService
      .post(`/core/management/project-imperative`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateStrategicImperative = async ({ token, params }) => {
  try {
    return await clientPublicService
      .put(`/core/management/project-imperative`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteStrategicImperative = async ({ params, token }) => {
  try {
    return await clientPublicService
      .delete(`/core/management/project-imperative`, {
        data: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
